import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../history';

export class PremiumUpgradeBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovered: false
        };
    }

    handleUpgradeClick = (e) => {
        e.preventDefault();
        history.push('/dashboard/premium');
    };

    render() {
        return (
            <div className="relative overflow-hidden bg-[#0F0C05] p-6 sm:p-12 rounded-2xl my-4 text-white">
                {/* Dark gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-[#0F0C05] via-[#1A1505] to-[#0F0C05]" />

                {/* Enhanced Gold Accent Glows */}
                <div className="absolute -bottom-32 right-0 w-2/3 h-[150%] bg-gradient-to-tl from-[#FFD700]/30 via-[#F5C211]/20 to-transparent blur-3xl" />
                <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-[#FFD700]/25 via-[#F5C211]/15 to-transparent blur-2xl" />

                {/* Additional subtle gold accent */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#FFD700]/[0.05] to-[#F5C211]/[0.08]" />

                <div className="flex flex-col lg:flex-row items-center justify-between relative z-10 gap-8 lg:gap-0">
                    {/* Content */}
                    <div className="relative z-10 w-full lg:max-w-xl">
                        <h1 className="text-3xl sm:text-4xl font-bold mb-3">
                            Unlock your Bot's full potential with Premium
                        </h1>

                        <div className="flex flex-wrap gap-3 mb-5">
                            <div className="bg-[#1A1505] px-4 py-2 rounded-lg flex items-center gap-2">
                                <span className="text-[#FFD700]">✓</span>
                                <span className="text-gray-300">Unlimited Commands</span>
                            </div>
                            <div className="bg-[#1A1505] px-4 py-2 rounded-lg flex items-center gap-2">
                                <span className="text-[#FFD700]">✓</span>
                                <span className="text-gray-300">Custom Status</span>
                            </div>
                            <div className="bg-[#1A1505] px-4 py-2 rounded-lg flex items-center gap-2">
                                <span className="text-[#FFD700]">✓</span>
                                <span className="text-gray-300">No BotGhost Branding</span>
                            </div>
                            <div className="bg-[#1A1505] px-4 py-2 rounded-lg flex items-center gap-2">
                                <span className="text-[#FFD700]">✓</span>
                                <span className="text-gray-300">Premium Modules</span>
                            </div>
                        </div>

                        <p className="text-base sm:text-lg leading-relaxed text-gray-300 mb-5 lg:pr-12">
                            Take your bot to the next level with premium features. Get access to all current and future modules, set your own status message, remove BotGhost branding, and enjoy access to premium modules.
                        </p>

                        <button
                            onClick={this.handleUpgradeClick}
                            className="relative w-full sm:w-auto px-8 py-3 rounded-lg font-semibold overflow-hidden
                                transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 
                                group cursor-pointer"
                        >
                            {/* Gradient background */}
                            <div className="absolute inset-0 bg-gradient-to-r from-[#FFD700] via-[#F5C211] to-[#FFC107] 
                                group-hover:opacity-90 transition-opacity" />

                            {/* Shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
                                translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                            {/* Button shadow */}
                            <div className="absolute inset-0 shadow-xl shadow-[#FFD700]/20" />

                            {/* Button text */}
                            <span className="relative z-10 text-[#0F0C05]">Upgrade to Premium</span>
                        </button>
                    </div>

                    {/* Promo Image - Hidden on mobile */}
                    <div className="hidden lg:block relative z-10 w-[400px] mr-16">
                        <div className="">
                            <img
                                src={'https://cdn.botghost.com/Sale+2025+animated01.webp'}
                                alt="Premium Features"
                                className="w-full h-auto transform hover:scale-105 transition-transform duration-500"
                            />
                        </div>
                    </div>
                </div>

                {/* Floating stars decoration */}
                <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-20">
                    <div className="absolute top-2 right-[5%] text-[#FFD700]/40 text-3xl animate-pulse delay-100">✦</div>
                    <div className="absolute top-16 right-[15%] text-[#FFD700]/50 text-2xl animate-pulse delay-300">✧</div>
                    <div className="absolute top-4 right-[25%] text-[#FFD700]/40 text-3xl animate-pulse delay-500">✦</div>
                    <div className="absolute top-20 right-[35%] text-[#FFD700]/50 text-2xl animate-pulse delay-700">✧</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumUpgradeBanner); 